import axios from 'axios';
import { Layout } from 'components/Layout';
import Cookies from 'js-cookie';
import { useRouter } from 'next/router';
import { useEffect } from 'react';
import { Spinner3 } from 'styled-icons/evil';
import {
  GET_IN_ADDRESS_COOKIE_KEY,
  GET_IN_ADDRESS_IS_BY_IP_COOKIE_KEY,
  GET_IN_CITY_COOKIE_KEY,
  GET_IN_LATITUDE_COOKIE_KEY,
  GET_IN_LONGITUDE_COOKIE_KEY,
} from 'utils/constants';
import * as S from './styles';

type IpLocation = {
  success: boolean;
  data: {
    colo: string;
    country: string;
    city: string;
    continent: string;
    lat: string;
    lng: string;
    postalCode: string;
    region: string;
    regionCode: string;
    timeZone: string;
  };
};

export const GetLocation = () => {
  const { back, push, query } = useRouter();

  useEffect(() => {
    (async function getLocationClient() {
      if (Cookies.get(GET_IN_ADDRESS_COOKIE_KEY)) {
        return push((query.resolvedUrl || '/').toString());
      }

      const { data } = (await axios.get(
        'https://user.getinapis.com/ip-location'
      )) as { data: IpLocation };

      if (!data?.success) return push('/location');

      const { region, city, lat, lng } = data.data;

      if (!region || !city || !lat || !lng) return push('/location');

      const dateOneYearOlder = new Date();
      dateOneYearOlder.setFullYear(dateOneYearOlder.getFullYear() + 1);

      Cookies.set(GET_IN_LATITUDE_COOKIE_KEY, lat);
      Cookies.set(GET_IN_LONGITUDE_COOKIE_KEY, lng);
      Cookies.set(GET_IN_ADDRESS_COOKIE_KEY, `${region} ${city}`);
      Cookies.set(GET_IN_CITY_COOKIE_KEY, city);
      Cookies.set(GET_IN_ADDRESS_IS_BY_IP_COOKIE_KEY, 'true');

      push((query.resolvedUrl || '/location').toString());
    })();
  }, [back, push, query]);

  return (
    <Layout>
      <S.Container>
        <Spinner3 />
      </S.Container>
    </Layout>
  );
};
